import { render } from "./ScoreInfo.vue?vue&type=template&id=9a2fad52"
import script from "./ScoreInfo.vue?vue&type=script&lang=js"
export * from "./ScoreInfo.vue?vue&type=script&lang=js"

import "./ScoreInfo.vue?vue&type=style&index=0&id=9a2fad52&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__